import { Model } from 'modules/core/lib/mobx-rest'

interface IVisit {
  [key: string]: any
}

class Visit extends Model<IVisit> {
  static urlRoot() {
    return '/posts/visits'
  }
}

export default Visit
